import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Formik } from 'formik';
import { useMutation } from '@apollo/client';

import { SEND_PASSWORD_RESET } from './queries';
import {
  Container,
  InnerContainer,
  Title,
  Instructions,
  Label,
  Input,
  Button,
  CancelButton,
} from './elements';

const ForgotPassword = ({ setShowForgotPassword }) => {
  const [formSubmitted, setFormSubmitted] = useState(false);

  const [sendPasswordReset] = useMutation(SEND_PASSWORD_RESET);

  const handleSubmit = values => {
    setFormSubmitted(true);
    sendPasswordReset({ variables: values });
  };

  return (
    <>
      <Helmet>
        <title>Forgot Password</title>
      </Helmet>

      <Container>
        {formSubmitted ? (
          <InnerContainer>
            <Title>Request Submitted</Title>

            <Instructions>
              If your email address is registered, you will receive an email
              with instructions and a link to reset your password.
            </Instructions>

            <Instructions>
              Please allow up to 10 minutes to receive the email.
            </Instructions>

            <CancelButton
              type="button"
              onClick={() => setShowForgotPassword(false)}
            >
              Return to Login
            </CancelButton>
          </InnerContainer>
        ) : (
          <InnerContainer>
            <Title>Enter your email below</Title>

            <Instructions style={{marginBottom: '4rem'}}>
              We will send you an access link to your registered
              email so you can change your password.
            </Instructions>

            <Formik
              initialValues={{ email: '' }}
              onSubmit={handleSubmit}
            >
              {props => (
                <form onSubmit={props.handleSubmit}>
                  <Input
                    type="email"
                    name="email"
                    placeholder="Email"
                  />
                  <Button type="submit">
                    Submit
                  </Button>
                  <CancelButton
                    type="button"
                    onClick={() => setShowForgotPassword(false)}
                  >
                    Cancel
                  </CancelButton>
                </form>
              )}
            </Formik>
          </InnerContainer>
        )}
      </Container>
    </>
  );
};

export default ForgotPassword;
